import { MAX_PAYMENT_AMOUNT_WITHOUT_TIP } from "../constants/form";
export const CARD_MAXIMUM_AMOUNT_DEFAULT = 5_000_00;
export const getCardMaximumAmount = (organizationCardMaximumAmount) => Math.min(MAX_PAYMENT_AMOUNT_WITHOUT_TIP, organizationCardMaximumAmount ?? CARD_MAXIMUM_AMOUNT_DEFAULT);
